export default "__VITE_ASSET__03682549__"